// extracted by mini-css-extract-plugin
module.exports = {"container":"RichContent-module--container--wa4tI"};